import { render } from "./EmailSetup.vue?vue&type=template&id=4f66c18c&scoped=true"
import script from "./EmailSetup.vue?vue&type=script&lang=js"
export * from "./EmailSetup.vue?vue&type=script&lang=js"

import "./EmailSetup.vue?vue&type=style&index=0&id=4f66c18c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f66c18c"]])

export default __exports__